/**
 * useSearch - Zustand store for managing global search modal state.
 *
 * Provides open/close/toggle actions for the search UI across the app.
 */
import { create } from "zustand";

type SearchStore = {
    isOpen: boolean
    onOpen: () => void
    onClose: () => void
    toggle: () => void
    localSearchQuery: string
    setLocalSearchQuery: (query: string) => void
    globalSearchQuery: string
    setGlobalSearchQuery: (query: string) => void
}

export const useSearch = create<SearchStore>((set, get) => ({
    isOpen: false,
    onOpen: () => set({ isOpen: true }),
    onClose: () => set({ isOpen: false }),
    toggle: () => set({ isOpen: !get().isOpen }),
    localSearchQuery: "",
    setLocalSearchQuery: (query: string) => set({ localSearchQuery: query }),
    globalSearchQuery: "",
    setGlobalSearchQuery: (query: string) => set({ globalSearchQuery: query }),
}))